var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 0.583313H4.66666C3.86166 0.583313 3.20833 1.23665 3.20833 2.04165V11.9583C3.20833 12.7633 3.86166 13.4166 4.66666 13.4166H9.33333C10.1383 13.4166 10.7917 12.7633 10.7917 11.9583V2.04165C10.7917 1.23665 10.1383 0.583313 9.33333 0.583313ZM6.99999 12.8333C6.51583 12.8333 6.12499 12.4425 6.12499 11.9583C6.12499 11.4741 6.51583 11.0833 6.99999 11.0833C7.48416 11.0833 7.87499 11.4741 7.87499 11.9583C7.87499 12.4425 7.48416 12.8333 6.99999 12.8333ZM4.37499 10.5H9.62499V2.33331H4.37499V10.5Z",
    fill: "#6C37CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.5655fabc82a34fa9121f517603060314.svg";
export { ForwardRef as ReactComponent };